import React, { Component } from "react";

import { Route, Redirect, RouteProps } from "react-router-dom";
import { ApplicationPaths, QueryParameterNames } from "./ApiAuthorizationConstants";
import { authService } from "./AuthorizeService";

export default class AuthorizeRoute extends Component<
    RouteProps,
    { ready: boolean; authenticated: boolean }
> {
    private subscription: number | undefined;

    constructor(props: RouteProps) {
        super(props);

        this.state = {
            ready: false,
            authenticated: false,
        };
    }

    componentDidMount(): void {
        this.subscription = authService.subscribe(() => this.authenticationChanged());
        this.populateAuthenticationState();
    }

    componentWillUnmount(): void {
        if (this.subscription) {
            authService.unsubscribe(this.subscription);
        }
    }

    async populateAuthenticationState(): Promise<void> {
        const authenticated = await authService.isAuthenticated();
        this.setState({ ready: true, authenticated });
    }

    async authenticationChanged(): Promise<void> {
        this.setState({ ready: false, authenticated: false });
        await this.populateAuthenticationState();
    }

    render(): JSX.Element {
        const { ready, authenticated } = this.state;
        const link = document.createElement("a");
        if (this.props.path && !Array.isArray(this.props.path)) {
            link.href = this.props.path as string;
        }

        const returnUrl = `${link.protocol}//${link.host}${link.pathname}${link.search}${link.hash}`;
        const redirectUrl = `${ApplicationPaths.Login}?${
            QueryParameterNames.ReturnUrl
        }=${encodeURIComponent(returnUrl)}`;
        if (!ready) {
            return <div />;
        }
        const { component: ComponentToRender, ...rest } = this.props;
        return (
            <Route
                {...rest}
                render={(props) => {
                    if (authenticated && ComponentToRender) {
                        return <ComponentToRender {...props} />;
                    }
                    return <Redirect to={redirectUrl} />;
                }}
            />
        );
    }
}
